import React from 'react';
import {
  Dialog,
  IconButton,
  styled,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const StyledDialog = styled(Dialog)({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    width: '100%',
    height: '100%',
    [`@media (min-width: 768px)`]: {
      margin: '0 auto',
    },
    [`@media (min-width: 992px)`]: {},
    [`@media (min-width: 1280px)`]: {},
    '&::-webkit-scrollbar': {
      width: 6,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(149, 152, 154, 0.43)',
      borderRadius: 5,
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(149, 152, 154, 1)',
    },
  },
});

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const MapDialog = ({
  onClose,
  isOpen,
  exhibitor,
  locale,
  thematic = '',
  token = '',
}) => {
  if (!isOpen) return null;
  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <StyledDialog
      onClose={onClose}
      open={isOpen}
      maxWidth={'100%'}
      height={'90%'}
      id="appointment-menu"
      keepMounted
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div
        tabIndex={0}
        role="button"
        onClick={onClose}
        style={{
          position: 'absolute',
          top: isSmDown ? 25 : 20,
          right: isSmDown ? 25 : 30,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={'small'} />
        </StyledIconButton>
      </div>
      <div style={{ padding: '20px', height: '100%' }}>
        <iframe
          id="map"
          style={{
            width: '100%',
            height: '100%',
            border: 'none',
            paddingTop: '0px',
            paddingBottom: '0px',
            minHeight: '100%',
          }}
          data-once="sdm-map-page"
          src={
            exhibitor
              ? `https://indoor.woosmap.com/salone-del-mobile/map/?language=${locale}${
                  thematic ? `&thematic=${thematic}` : ''
                }&building=${exhibitor?.hall}${token}&poi_id=${
                  exhibitor?.salesforceId
                }`
              : `https://indoor.woosmap.com/salone-del-mobile/map/?language=${locale}${token}`
          }
        ></iframe>
      </div>
    </StyledDialog>
  );
};

export { MapDialog };
